import { createContext } from 'react';

interface DataContextType {
    registrationData: any,
    setRegistrationData: any
}

const DataContext = createContext<DataContextType>({
    registrationData: {}, //see dataContextConfig.js
    setRegistrationData: () => {}
});

export default DataContext;